type RouteParams = ReadonlyMap<string, string>;
type RouteMatchResult = { readonly matches: false } |
  { readonly matches: true; readonly params: RouteParams };

export interface RouteMatcher {
  match(path: string): RouteMatchResult;
}

class ExactMatcher implements RouteMatcher {
  constructor(readonly route: string) {
  }

  match = (path: string): RouteMatchResult => {
    if (path === this.route)
      return {matches: true, params: new Map()};
    return {matches: false};
  };
}

class PrefixMatcher implements RouteMatcher {
  constructor(readonly prefix: string,
              readonly paramName: string) {
  }

  match = (path: string): RouteMatchResult => {
    if (path.startsWith(this.prefix)) {
      let params = new Map<string, string>();
      const paramValue = path.substring(this.prefix.length);
      params.set(this.paramName, paramValue);
      return {matches: true, params: params};
    }

    return {matches: false};
  };
}

const prefixedRouteRegexp = new RegExp('^([^:]*):([a-zA-Z][a-zA-Z0-9]*)$');

function prepareMatcher(route: string): RouteMatcher {
  if (!route.includes(':'))
    return new ExactMatcher(route);

  const matches = prefixedRouteRegexp.exec(route);
  if (matches === null)
    throw new Error(`Provided route [${route}] is not exact match or prefix match`);

  return new PrefixMatcher(matches[1], matches[2]);
}

const matchers = new Map<string, RouteMatcher>();

export function routeMatcher(route: string): RouteMatcher {
  let matcher = matchers.get(route);
  if (matcher === undefined) {
    matcher = prepareMatcher(route);
    matchers.set(route, matcher);
  }
  return matcher;
}
